import { cn } from "@netlify/ui";
import { InlineSpacer } from "../InlineSpacer.jsx";

export type CardFooterProps = {
  as?: React.ElementType | undefined;
  children?: React.ReactNode | undefined;
  className?: string | undefined;
};

export const CardFooter = ({
  as: Component = "footer",
  className,
  children,
  ...rest
}: CardFooterProps) => (
  <Component className={cn("tw-pt-6", className)} {...rest}>
    <InlineSpacer>{children}</InlineSpacer>
  </Component>
);
